export default __webpack_public_path__ + "static/media/AbzalSuan.1877e7b9.pdf";